import { createSlice } from '@reduxjs/toolkit';

const messageSlice = createSlice({
  name: 'message',
  initialState: {
    message: '',
  },
  reducers: {
    addMessage: (state, action) => {
      state.message = action.payload;
    },
  },
});

export const { addMessage } = messageSlice.actions;

export default messageSlice.reducer;
